import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const NAV = [
  { id: "inicio", label: "Inicio" },
  { id: "servicios", label: "Servicios" },
  { id: "cotizador", label: "Cotizador" },
  { id: "agendar", label: "Agendar" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-slate-950/80 border-b border-white/5"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between">
        <button
          onClick={() => goTo("inicio")}
          data-testid="nav-logo-button"
          className="hover:opacity-90 transition-opacity"
          aria-label="Ir al inicio"
        >
          <Logo size="md" />
        </button>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((item) => (
            <button
              key={item.id}
              onClick={() => goTo(item.id)}
              data-testid={`nav-link-${item.id}`}
              className="px-4 py-2 text-sm font-medium text-slate-300 hover:text-white rounded-lg hover:bg-white/5 transition-colors"
            >
              {item.label}
            </button>
          ))}
          <Link
            to="/portfolio"
            data-testid="nav-link-portfolio"
            className="px-4 py-2 text-sm font-medium text-slate-300 hover:text-white rounded-lg hover:bg-white/5 transition-colors"
          >
            Portafolio
          </Link>
          <button
            onClick={() => goTo("cotizador")}
            data-testid="nav-cta-quote"
            className="ml-3 px-5 py-2.5 text-sm font-semibold text-white bg-orange-500 hover:bg-orange-600 rounded-lg shadow-[0_0_18px_rgba(249,115,22,0.35)] hover:shadow-[0_0_28px_rgba(249,115,22,0.55)] transition-all"
          >
            Cotizar ahora
          </button>
        </nav>

        {/* Mobile toggle */}
        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2 rounded-lg text-slate-300 hover:text-white hover:bg-white/5"
          aria-label="Abrir menú"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile nav */}
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-white/5 bg-slate-950/95 backdrop-blur-xl"
        >
          <div className="px-4 py-4 flex flex-col gap-1">
            {NAV.map((item) => (
              <button
                key={item.id}
                onClick={() => goTo(item.id)}
                data-testid={`nav-mobile-link-${item.id}`}
                className="text-left px-3 py-3 text-base font-medium text-slate-200 hover:text-white hover:bg-white/5 rounded-lg"
              >
                {item.label}
              </button>
            ))}
            <Link
              to="/portfolio"
              data-testid="nav-mobile-link-portfolio"
              className="text-left px-3 py-3 text-base font-medium text-slate-200 hover:text-white hover:bg-white/5 rounded-lg"
            >
              Portafolio
            </Link>
            <button
              onClick={() => goTo("cotizador")}
              data-testid="nav-mobile-cta"
              className="mt-2 px-5 py-3 text-base font-semibold text-white bg-orange-500 hover:bg-orange-600 rounded-lg"
            >
              Cotizar ahora
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
